import { IonButton } from '@ionic/react'
import { FaFilePdf } from 'react-icons/fa6'
import React from 'react'

import './quickStartLink.css'

const QuickStartLink = () => (
    <p className="quick-start-link">
        <IonButton
            fill="outline"
            href="https://autoroster.io/Quick-Start-Guide.pdf"
            target="_blank"
            rel="noopener noreferrer"
        >
            <FaFilePdf />
            <span>Quick Start Guide for club coaches</span>
        </IonButton>
    </p>
)

export default QuickStartLink
